import React, {useState} from "react";
import { Button, FormGroup, Modal} from "react-bootstrap";
import { Form, Input} from 'antd';
import { ImageElement,Breadcrumb, LoginHeader} from "../../components";
import { Link } from "react-router-dom";
   function ServiceTrack() {
      const breadcrumb = [
         {
         path: '/dashboard',
         name: 'Home',
         },
         {
         path: '#',
         name: 'Service Track',
         }
      ];
      const [show, setShow] = useState(false);
      const [serviseTrackSidebar, setServiseTrackSidebar] = useState(false);
      const handleClose = () => setShow(false);
      const handleShow = () => setShow(true);
      const { TextArea } = Input;

      const sidebarOpen = () => {
         setServiseTrackSidebar(true);
         document.querySelector('body').classList.add('overflow-hidden');
      }
      const sidebarClose = () => {
         setServiseTrackSidebar(false);         
         document.querySelector('body').classList.remove('overflow-hidden');
      }
   return(
   <>
   <LoginHeader/>
   <div className="main-content serviceTrackPage">
      {/* page content */}
      <div className="pageContent p-0">
         <div className="serviceTrack position-relative">
         <Link className="primary text-capitalize serviceTrack_sidebar d-lg-none"  onClick={sidebarOpen} > <em className="gg-list"></em> </Link>
            <div className="serviceTrack_map">
               <ImageElement source="map-image.png" className="img-fluid w-100 h-100"/>
            </div>
            <div className={`serviceTrack_box position-absolute ${serviseTrackSidebar && 'sidebarOpen'}`}>
               <div className="d-flex justify-content-between align-items-start">
                  <Breadcrumb title="Service Track" breadcrumb={breadcrumb}/>
                  <Link className="primary text-capitalize serviceTrack_boxtoggle d-lg-none d-block" onClick={sidebarClose}> <em className="gg-close"/></Link>
               </div>
               <div className="serviceTrack_detail bg-white">
                  <div className="d-flex align-items-start">
                     <div className="serviceTrack_img">
                        <ImageElement source="track-1.png" className="img-fluid"/>
                     </div>
                     <div className="serviceTrack_name">
                        <h3>Steven S. Hurd</h3>
                        <ul className="list-unstyled d-flex starRating mb-0 justify-content-center">
                           <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                           <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                           <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                           <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                           <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                        </ul>
                        <p className="phone mb-0">91 5353535353</p>
                     </div>
                  </div>
                  <div className="serviceTrack_cnt text-break">
                     <div className="serviceTrack_address">
                        <em className="gg-marker"/>3050 Crestview Terrace Marble Falls, TX 78654
                     </div>
                     <Button variant="light w-100 text-capitalize" onClick={handleShow}>Cancel Job</Button>
                  </div>
               </div>
               <div className="serviceTrack_location bg-white">
                  <p className="addr">21 mins to reach & 4.67 miles away</p>
                  <ul className="list-unstyled serviceTrack_step">
                     <li className="serviceTrack_step_item d-flex align-items-center position-relative">
                        <span className="serviceTrack_step_left "><em className="gg-check"/></span>
                        <div className="serviceTrack_step_right">
                           <p><strong>Steven S. Hurd</strong><span className="ft-14"> Provider accepted the request.</span> </p>
                           <span className="time">11:00 AM</span>
                        </div>
                     </li>
                     <li className="serviceTrack_step_item d-flex align-items-center position-relative">
                        <span className="serviceTrack_step_left"><em className="gg-check"/></span>
                        <div className="serviceTrack_step_right">
                           <p><strong>Steven S. Hurd</strong><span className="ft-14"> Provider have arrived to service location.</span></p>
                           <span className="time">11:05 AM</span>
                        </div>
                     </li>
                     <li className="serviceTrack_step_item d-flex align-items-center position-relative">
                        <span className="serviceTrack_step_left"><em className="gg-check"/></span>
                        <div className="serviceTrack_step_right">
                           <p><strong>Steven S. Hurd</strong> <span className="ft-14"> Provider have started the service.</span></p>
                           <span className="time">11:10 AM</span>
                        </div>
                     </li>
                  </ul>
               </div>
            </div>
         </div>
      </div>
   </div>
   <Modal show={show} onHide={handleClose} size="lg" centered id="cancelBooking" className="cancelBooking" backdrop="static">
      <Modal.Header closeButton className="align-items-start">
         <div>
            <Modal.Title className="text-uppercase">Cancel Booking</Modal.Title>
         </div>
      </Modal.Header>
      <Modal.Body>
         <Form className="cancelBooking_textarea">
            <FormGroup className="form-group">
               <label className="ant-label">Reason</label>
               <TextArea rows={8} placeholder="maxLength is 6" maxLength={8} value=""></TextArea>
            </FormGroup>
            <div className="d-flex align-items justify-content-end flex-wrap mt-lg-4 mt-2">
               <Button variant="light" className="min-200 me-3"  onClick={handleClose}>Cancel</Button>
               <Button variant="primary" className="min-200">Continue</Button>
            </div>
         </Form>
      </Modal.Body>
   </Modal>
   </>
   );
}
export default ServiceTrack;